module.exports = __webpack_public_path__ + "img/mycoupons.185ea19c.png";